import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { Observable, of, switchMap, tap, map, throwError, catchError } from 'rxjs';
import { ConfigService } from '../config.service';
import { UiSafeStaff } from './commonInterfaces';
import { DataTransform } from './dataTransformFunctions';

export interface CommentResponse {
  comments: WorkItemComment[],
  staff: UiSafeStaff[]
}

export interface CommentEdited {
  comments: WorkItemCommentHistory[],
  staff: UiSafeStaff[]
}
export interface WorkItemComment {
  workItemCommentId: number,
  workItemId: number,
  commentText: string,
  replyCommentId?: number,
  commentDate: Date,
  staffId: number,
  staff?: UiSafeStaff
}

export interface WorkItemCommentHistory {
  commentHistoryId: number,
  workItemCommentId: number,
  workItemId: number,
  staffId: number,
  staff?: UiSafeStaff,
  oldCommentText: string,
  editedDay: Date,
  commentText: string,
  createdAt: Date
}

@Injectable({
  providedIn: 'root'
})
export class CommentService {

  constructor(
    private http: HttpClient,
    private config: ConfigService
  ) { }


  getComments(workItemId: number): Observable<WorkItemComment[]> {
    return this.http.get<CommentResponse>(this.config.dataApiUrl + '/incidents/' + workItemId + '/comments').pipe(
      switchMap(DataTransform.replaceCommentDatesArray),
      switchMap(DataTransform.attachStaffToComment),
      switchMap(resp => {
        return of(resp.comments)
      }),
      tap(comments => {
        this.sortDateAscending(comments);
      })
    );
  }

  addComment(workItemId: number, commentText: string, replyCommentId?: number): Observable<WorkItemComment> {
    const comment: Partial<WorkItemComment> = {
      workItemId: workItemId,
      commentText: commentText,
    }

    if (replyCommentId) {
      comment.replyCommentId = replyCommentId;
    }

    return this.http.post<CommentResponse>(this.config.dataApiUrl + '/incidents/' + workItemId + '/comment', comment).pipe(
      switchMap(DataTransform.replaceCommentDatesArray),
      switchMap(DataTransform.attachStaffToComment),
      switchMap(resp => {
        return of(resp.comments[0])
      })
    );

  }

    saveCommentEdit(workItemId: number, commentText: string, workItemCommentId: number): Observable<WorkItemComment> {
      const comment: Partial<WorkItemComment> = {
        workItemCommentId: workItemCommentId,
        workItemId: workItemId,
        commentText: commentText,
        
      };
    
      return this.http.patch<WorkItemComment>(
        this.config.dataApiUrl + '/incidents/' + workItemId + '/edit-comment/' + workItemCommentId, comment
      ).pipe(
        map((response: WorkItemComment) => {
          
          return response;
        }),
        catchError(error => throwError(() => error))
      );
    }

  /**
   * Sorts the provided comment array in place by date ascending
   * @param comments Array of comments to sort
   * @returns 
   */
  sortDateAscending(comments: WorkItemComment[]) {
    return comments.sort((a, b) => {
      return a.commentDate.getTime() - b.commentDate.getTime();
    })
  }


}
